import { createInjectionKey as n } from "../../_utils/vue/create-injection-key.js";
const t = n("n-form"), e = n("n-form-item-insts");
export {
  t as formInjectionKey,
  e as formItemInstsInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/form/src/context.js
// module id = 467
// module chunks = 41